/** Map staff KYC API payloads to the shape expected by admin KYC UI components. */
import { normalizeTimelineItems } from "./timeline";

export function mapStaffKycListItem(item) {
  if (!item) return null;
  return {
    id: item.id,
    applicantId: item.applicant_id,
    applicantName: item.applicant_name,
    email: item.email,
    accountType:
      item.account_type === "member" ? "cooperative_member" : "standalone_investor",
    ninMasked: item.nin_masked,
    status: item.status,
    matchResult: item.match_result,
    submittedAt: item.submitted_at,
    reviewedAt: item.reviewed_at,
    assignedReviewer: item.assigned_reviewer,
    reviewedBy: item.reviewed_by,
  };
}

export function mapStaffKycDetail(item) {
  if (!item) return null;
  return {
    id: item.id,
    applicantId: item.applicant_id,
    applicantName: item.applicant_name,
    email: item.email,
    phone: item.phone,
    accountType:
      item.account_type === "member" ? "cooperative_member" : "standalone_investor",
    legalName: item.legal_name,
    portalName: item.portal_name,
    dateOfBirth: item.date_of_birth,
    portalDateOfBirth: item.portal_date_of_birth,
    ninMasked: item.nin_masked,
    status: item.status,
    matchResult: item.match_result,
    submittedAt: item.submitted_at,
    reviewedAt: item.reviewed_at,
    reviewedBy: item.reviewed_by,
    assignedReviewer: item.assigned_reviewer,
    rejectionReason: item.rejection_reason,
    resubmissionReason: item.resubmission_reason,
    providerResponse: item.provider_response,
    timeline: normalizeTimelineItems(item.timeline),
    previousSubmissionIds: item.previous_submission_ids || [],
    notes: (item.notes || []).map((note) => ({
      id: note.id,
      note: note.note,
      staffName: note.staff_name,
      createdAt: note.created_at,
    })),
  };
}
